import React, { Fragment } from 'react';
import { Provider, useDispatch } from 'react-redux';
import ReactDOM from 'react-dom';
import { createBrowserHistory, History } from 'history';
import createSagaMiddleware from '@redux-saga/core';
import { routerMiddleware } from 'connected-react-router';
import { ThemeProvider } from 'styled-components';

import App from './App';
import { RepositTheme } from './base/theme';
import { GlobalStyle } from './base/style';
import { getRootReducer } from './redux/root.reducer';
import rootSaga from './redux/root.saga';
import { configureStore } from '@reduxjs/toolkit';

// create the saga middleware
export const sagaMiddleware = createSagaMiddleware();
export const history: History<any> = createBrowserHistory();

// mount it on the Store
export const store = configureStore({
  reducer: getRootReducer(history),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware, routerMiddleware(history)),
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>(); // Export a hook that can be reused to resolve types

// API clients keep the token they restore on a 401 (api.utils).
sagaMiddleware.setContext({ dispatch: store.dispatch });
sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={RepositTheme}>
      <Fragment>
        <App />
        <GlobalStyle />
      </Fragment>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);
